import { AssetSummaryItem } from '../../Services/serviceURL';

export type ExtractedSite = {
  siteId: string;
  site: string;
  customerId: string;
  customerName: string;
};

export type ExtractedPlant = {
  plantId: string;
  plantName: string;
  siteId: string;
  siteName: string;
  customerId: string;
  customerName: string;
};

export const mergeSitesFromAssets = (assets: AssetSummaryItem[], existing: ExtractedSite[]): ExtractedSite[] => {
  const siteMap = new Map(existing.map((site) => [site.siteId, site]));

  assets.forEach((asset) => {
    if (asset.siteId && asset.siteName && !siteMap.has(asset.siteId)) {
      siteMap.set(asset.siteId, {
        siteId: asset.siteId,
        site: asset.siteName,
        customerId: asset.customerId || '',
        customerName: asset.customerName || '',
      });
    }
  });

  return Array.from(siteMap.values()).sort((a, b) => {
    const customerCompare = a.customerName.localeCompare(b.customerName);
    if (customerCompare !== 0) return customerCompare;
    return a.site.localeCompare(b.site);
  });
};

export const mergePlantsFromAssets = (assets: AssetSummaryItem[], existing: ExtractedPlant[]): ExtractedPlant[] => {
  const plantMap = new Map(existing.map((plant) => [plant.plantId, plant]));

  assets.forEach((asset) => {
    if (asset.plantId && asset.plantName && !plantMap.has(asset.plantId)) {
      plantMap.set(asset.plantId, {
        plantId: asset.plantId,
        plantName: asset.plantName,
        siteId: asset.siteId || '',
        siteName: asset.siteName || '',
        customerId: asset.customerId || '',
        customerName: asset.customerName || '',
      });
    }
  });

  return Array.from(plantMap.values()).sort((a, b) => {
    const siteCompare = a.siteName.localeCompare(b.siteName);
    if (siteCompare !== 0) return siteCompare;
    return a.plantName.localeCompare(b.plantName);
  });
};
